import { useAuthenticator } from '@aws-amplify/ui-react';
import rootReducer from '@reducers';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import styled from 'styled-components';

import Spinner from '@shared/Spinner';
import apiMiddleware from '@src/api/middleware';

import Routes from './routes';

export const history = createBrowserHistory();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = applyMiddleware(
  routerMiddleware(history),
  thunk,
  apiMiddleware
);

export const store = (preloadedState = {}) =>
  createStore(
    rootReducer(history),
    preloadedState,
    composeEnhancers(middleware)
  );

const invokedStore = store();

const LoadingContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`;

const LoggedInUser = () => {
  const { route } = useAuthenticator(context => [context.route]);

  if (route === 'authenticated') {
    return (
      <Provider store={invokedStore}>
        <Routes />
      </Provider>
    );
  }

  return (
    <LoadingContainer>
      <div>Enigma Screen UI - {process.env.REACT_APP_ENV}</div>
    </LoadingContainer>
  );
};

export default LoggedInUser;

// expose store when run in Cypress
if (window.Cypress) {
  window.store = invokedStore;
}
